import type { PayOrderPrintContent, TextEntity } from "@/api/business/types/printing"
import type { OrderDetailVO } from "@/api/user/types/member"
import { getOrderDetailInfo } from "@/api/business/order"
import { getOpeningTableInfoByRecord } from "@/api/business/table"
import { madePrintInfo } from "@/utils/print"
import { buildReceiptPaymentInfo } from "./receiptPaymentInfo"
import { resolveReceiptTableChargeOptions } from "./receiptTableChargeOptions"

export function buildCheckoutReceiptPaymentInfo(order: OrderDetailVO): TextEntity[] {
  return buildReceiptPaymentInfo(order, { mergePaymentRows: true })
}

export async function fetchCheckoutReceiptPrintContent(orderId: number): Promise<PayOrderPrintContent> {
  const response = await getOrderDetailInfo(orderId)
  if (response.code !== 0 || !response.data) {
    throw new Error(response.msg || "获取结账单数据失败")
  }
  let tableChargeOptions = {}
  try {
    tableChargeOptions = await resolveReceiptTableChargeOptions(response.data, {
      fetchOpeningTableInfoByRecord: getOpeningTableInfoByRecord,
    })
  } catch (error) {
    console.warn("Resolve automatic receipt table charge details failed", error)
  }
  return madePrintInfo(
    response.data,
    buildCheckoutReceiptPaymentInfo(response.data),
    0,
    tableChargeOptions,
  )
}
